import React, { Component } from "react";
import { CreateFeatureDialog } from "../../components/features/CreateFeatureDialog";
import { CreateFeatureButton } from "../../components/features/CreateFeatureButton";
import moment from "moment-timezone";
import { withRouter } from "react-router-dom";
import { languages } from "../../constants/languages";

class CreateFeatureContainer extends Component {
  state = {
    useType: "0",
    what: languages.features.iWant + " ",
    why: languages.features.because + " ",
    category: "0",
    step: 0,
    submitDisabled: false,
    open: false
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open });
  };

  handleChange = e => {
    let toUpdate = {};
    toUpdate[e.target.name] = e.target.value;
    this.setState(toUpdate);
  };

  handleCategoryClick = (e, key) => {
    this.setState({ category: key });
  };

  handleWhatChange = e => {
    let what = e.target.value;
    if (
      what.slice(0, languages.features.iWant.length + 1) ===
      languages.features.iWant + " "
    ) {
      this.setState({ what: what });
    }
  };

  handleWhyChange = e => {
    let why = e.target.value;
    if (
      why.slice(0, languages.features.because.length + 1) ===
      languages.features.because + " "
    ) {
      this.setState({ why: why });
    }
  };

  handleNext = () => {
    let validate = {
      0: true,
      1:
        this.state.what.slice(languages.features.iWant.length + 1).trim()
          .length > 0,
      2:
        this.state.why.slice(languages.features.because.length + 1).trim()
          .length > 0,
      3: true
    };
    if (validate[this.state.step]) {
      if (this.state.step === 3 && !this.state.submitDisabled) {
        this.handleCreate();
      } else {
        this.setState({ step: this.state.step + 1 });
      }
    }
  };

  handleBack = () => {
    this.setState({ step: this.state.step - 1 });
  };

  getIdeaString = () => {
    let whatSliced = this.state.what
      .slice(languages.features.iWant.length + 1)
      .trim();
    let punctuations = ".,:;!?";
    while (punctuations.indexOf(whatSliced[whatSliced.length - 1]) !== -1) {
      whatSliced = whatSliced.slice(0, -1);
    }

    let asWhat = {
      0: languages.features.asOrganizer,
      1: languages.features.asTeam,
      2: languages.features.asSupporter
    };

    let whySliced = this.state.why
      .slice(languages.features.because.length + 1)
      .trim();

    let ideaString =
      asWhat[this.state.useType] +
      " " +
      languages.features.wantI +
      " " +
      whatSliced +
      ", " +
      languages.features.because.toLowerCase() +
      " " +
      whySliced;
    return ideaString;
  };

  handleCreate = () => {
    let languageIsNL = languages.getLanguage() === "nl";

    if (!this.state.submitDisabled) {
      this.setState({ submitDisabled: true });
      let feature = {
        useType: this.state.useType,
        what: this.state.what,
        why: this.state.why,
        ideaString: this.getIdeaString(),
        category: this.state.category,
        date: moment().unix(),
        uid: this.props.user.uid
      };

      if (!languageIsNL) {
        feature["lang"] = languages.getLanguage() || null;
      }

      let db = window.firebase.firestore();

      let featureDoc = db.collection("features").doc();

      featureDoc
        .set(feature)
        .then(doc => {
          this.toggleDialog();
          //   this.props.history.push("features");
        })
        .catch(error => {
          console.log(error.message);
          this.setState({ submitDisabled: false });
        });
    }
  };

  render() {
    let whatSliced = this.state.what
      .slice(languages.features.iWant.length + 1)
      .trim();
    let punctuations = ".,:;!?";
    while (punctuations.indexOf(whatSliced[whatSliced.length - 1]) !== -1) {
      whatSliced = whatSliced.slice(0, -1);
    }

    let ideaString = this.getIdeaString();

    return (
      <div>
        <CreateFeatureDialog
          {...this.state}
          toggleDialog={this.toggleDialog}
          handleChange={this.handleChange}
          handleWhatChange={this.handleWhatChange}
          handleWhyChange={this.handleWhyChange}
          whatSliced={whatSliced}
          ideaString={ideaString}
          handleCategoryClick={this.handleCategoryClick}
          handleNext={this.handleNext}
          handleBack={this.handleBack}
        />
        <CreateFeatureButton toggleDialog={this.toggleDialog} />
      </div>
    );
  }
}

export default withRouter(CreateFeatureContainer);
